class Events {
  constructor(){
    this.state = {
      filters: {
        events: 'all'
      },
      sort: {
        field: 'time',
        order: 'desc'
      } 
    }
    
    this.sortBy = {
      timeDesc: function(a, b){
        return a.date >= b.date ? -1 : 1
      },
      timeAsc: function(a, b){
        return a.date <= b.date ? -1 : 1
      },
      viewsDesc: function(a, b){
        return a.views >= b.views ? -1 : 1
      }
    }
  }

  filterList(list){
    let arr = list && list.slice(0)
    return arr.filter(item => this.filterRow(item))
  }

  filterRow(item){
    const filtersObj = this.state.filters
    const filterFields = Object.keys(filtersObj)
    return filterFields.every(field => {
      let filterValue = filtersObj[field]

      switch(field){
        case 'text':
          let sources = [item.title, item.description]

          return sources.some(s => {
            let text = filterValue.toLowerCase()

            return s.toLowerCase().includes(text)
          })
        case 'tag':
          return item.tags.includes(filterValue)
        case 'events':
          if(filterValue === 'all') return true
          if(filterValue === 'channels') return true
          if(filterValue === 'upcoming') return item && item.isUpcoming
          if(filterValue === 'past') return !item.isUpcoming

          return true
        default:
          return true
      }
    })
  }

  setFilter(field, value){
    let filters = this.state['filters'];

    switch(field){
      case 'text':
        filters['text'] = value;
        break;
      case 'tag':
        filters['tag'] = value;
        break;
      case 'events':
        filters['events'] = value;
        break;
      default:
        throw new Error(`Unknown filter field: ${field}`)
    }
  }

  isUpcoming(date) {
    const changeSelectorForUpcoming = new Date().getTime();
    const eventDateSeconds = new Date(date).addHours(12).getTime();

    return eventDateSeconds > changeSelectorForUpcoming;
  }

  getFilters() {
    return this.state.filters
  }

  sortList(list) {
    var arr = list.slice(0)
    var field = this.state['sort']['field']
    var order = this.state['sort']['order']

    if(field === 'time' && order === 'desc') return arr.sort(this.sortBy.timeDesc)
    if(field === 'time' && order === 'asc') return arr.sort(this.sortBy.timeAsc)
    if(field === 'views' && order === 'desc') return arr.sort(this.sortBy.viewsDesc)
  }

  setSort(field, order){
    this.state['sort']['field'] = field
    this.state['sort']['order'] = order
  }

}

export default new Events()



// WEBPACK FOOTER //
// ./src/services/events.js